import { IconButton } from "@mui/joy";
import { UserCheck, UserPlus } from "@phosphor-icons/react";
import { useEffect, useState } from "react";
import { apiFetch } from "../../../../utils/apiClient";

/**
 * Подписка на пользователя.
 *
 * Статус спрашиваем у сервера сам: снаружи его никто не знает, а держать его в
 * профиле ради одной кнопки незачем.
 *
 * @param {number} id - на кого подписываемся
 * @param {boolean} [itsme] - свой профиль: подписаться на себя нельзя
 */
export function ProfileButtonSubs({ id = 0, itsme = false, disabled = false }) {
    const [follow, setFollow] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (itsme || !id) return;

        let cancelled = false;

        (async () => {
            try {
                const res = await apiFetch(`/api/user/follow/${id}`, { method: 'GET' });
                if (!res.ok) throw new Error("Не удалось определить статус подписки");

                const data = await res.json();
                if (!cancelled) setFollow(data?.follow ?? false);
            } catch (err) {
                console.error("Ошибка при проверке подписки");
            }
        })();

        return () => { cancelled = true; };
    }, [id, itsme]);

    const handleToggle = async () => {
        if (!id || loading) return;

        setLoading(true);
        try {
            const res = await apiFetch(`/api/user/follow/${id}`, {
                method: follow ? "DELETE" : "POST",
            });

            if (!res.ok) throw new Error("Ошибка при изменении подписки");

            const data = await res.json();
            setFollow(data?.follow ?? !follow);
        } catch (err) {
            console.error("Ошибка при подписке/отписке:", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <IconButton
            onClick={handleToggle}
            color="primary"
            variant="soft"
            aria-label={follow ? "Отписаться" : "Подписаться"}
            aria-pressed={follow}
            loading={loading}
            sx={(theme) => ({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '2px',
                px: 2,
                py: 1,
                borderRadius: "999px",
                width: '56px',
                color: theme.palette.mode === 'dark'
                    ? theme.palette.primary[100]
                    : null,
                fontSize: '12px',
                '& svg': {
                    width: '24px',
                    height: '24px',
                }
            })}
            disabled={disabled || itsme || !id}
        >
            {follow ? <UserCheck size={24} /> : <UserPlus size={24} />}
        </IconButton>
    )
}
